import Line from './Line';
import Bar from './Bar';
import Bar2 from './Bar2';
import Pie from './Pie';
import DualLineViz from './DualLine';
import DualBarViz from './DualBar';
import ExceptionViz from './Exception';
import TableViz from './Table';
import BigNumberWithTrendLinesViz from './BigNumberWithTrendLines';

const visualisationMap = {
  line: Line,
  bar: Bar,
  bar2: Bar2,
  pie: Pie,
  dual_time: DualLineViz,
  dual_bar: DualBarViz,
  exception: ExceptionViz,
  table: TableViz,
  number_with_trend_lines: BigNumberWithTrendLinesViz,
};

export default visualisationMap;
